export default __webpack_public_path__ + "static/media/nonPremiumAnalyticsMobile.f68c7545.jpg";